<template>
  <section class="support-log">
    <div class="title-container">
      <h2>Support Log</h2>
      <v-radio-group
        v-model="type"
        :button="true"
        :list="typeOptions"
        @change="changeType"></v-radio-group>
    </div>
    <div class="log-container">
      <div
        v-for="(item, index) in logsData"
        :key="index"
        class="log-box">
        <div class="left">
          <span
            v-if="item.title === 'Address Updated'"
            class="icon-box edit-icon">
            <font-awesome-icon icon="pen" />
          </span>
          <span
            v-else-if="item.title === 'Remark'"
            class="icon-box remark-icon">
            <font-awesome-icon icon="sticky-note" />
          </span>
          <span
            v-else-if="item.title === 'Voice Call'"
            class="icon-box call-icon">
            <font-awesome-icon icon="phone" />
          </span>
          <span
            v-else-if="item.type==300&&item.sms_log_id==0"
            class="icon-box ticket-icon">
            <font-awesome-icon icon="user" />
          </span>
          <span
            v-else-if="item.type==300&&item.sms_log_id>0"
            class="icon-box call-icon">
            <font-awesome-icon icon="envelope" />
          </span>
          <span
            v-else-if="item.status&&isClaim&&item.type==201"
            class="icon-box sms-icon">
            <font-awesome-icon icon="pen" />
          </span>
          <span
            v-else
            class="icon-box sms-icon">
            <font-awesome-icon icon="comment" />
          </span>
        </div>
        <div class="right">
          <div
            class="info-container"
            :class="{ 'white': item.type==300,
                      'blue': isClaim&&[1].includes(item.status),
                      'purple': isClaim&&[2].includes(item.status),
                      'green': isClaim&&[3].includes(item.status),
                      'red': isClaim&&[4].includes(item.status)
            }">
            <div class="flex-sb">
              <span
                v-if="item.title"
                class="title">{{ item.title }}</span>
              <span
                v-if="isClaim&&!item.title"
                class="title">
                <span>Status : </span>
                <span
                  :class="{
                    'blue': [1].includes(item.status),
                    'purple': [2].includes(item.status),
                    'green': [3].includes(item.status),
                    'red': [4].includes(item.status)}">{{ item.status_language }}</span>
              </span>
              <span class="time">{{ item.created_at }}</span>
            </div>
            <div class="info">
              <span>
                {{ item.sender_type===1 ? 'CS': 'Customer' }}
                <span>{{ item.agent }}</span>
              </span>
              <span v-if="item.title === 'Voice Call'">
                Duration
                <span>{{ item.duration }}</span>
              </span>
            </div>
            <div
              v-if="false && item.title === 'Voice Call'"
              class="vidio-box">
              <v-audio src="http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" />
            </div>
            <div
              v-if="item.message"
              class="message-content">
              <span>{{typeof item.message === 'object'? item.message.content: item.message  }}</span>
              <p
                v-if="item.type==300&&item.sms_log_id>0"
                class="blue_2 fs-14 pointer mg-t-5 fs-14"
                @click="handlerEmail(item.sms_log_id)"> View Full Message</p>
            </div>
            <div
              v-if="isClaim"
            >
              <table
                class="table mg-b-0">
                <tr
                  v-if="item.status_remark"
                  class="tr">
                  <td>Remarks</td>
                  <td v-html="changeLineData(item.status_remark)"></td>
                </tr>
                <tr
                  v-for="(file,index) in item.status_files"
                  :key="'file_'+index"
                  class="tr">
                  <td>
                    <p>{{file.name}}</p>
                    <p class="color-gray60 fs-12 fw-400">{{file.upload_date}}</p>
                  </td>
                  <td
                    class="blue pointer"
                  >
                    <span
                      class="blue pointer"
                      @click="openFile(file.url)">{{file.client_name}}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <file-container
            v-if="item.title == 'Remark' &&  item.message.remark_file"
            class="info-file"
            :marginBottom0="true"
            :fileData="item.message.remark_file" />
          <!--          <div-->
          <!--            v-if="item.type==300"-->
          <!--            class="file-container">-->
          <!--            <div class="file-box">-->
          <!--              <div class="file-info">-->
          <!--                <span>document123.pdf</span>-->
          <!--              </div>-->
          <!--              <div class="btn-box">-->
          <!--                <v-button-->
          <!--                  plain-->
          <!--                  type="primary"-->
          <!--                  size="small">Download</v-button>-->
          <!--              </div>-->
          <!--            </div> -->
          <!--          </div>-->
        </div>
      </div>
      <div
        v-if="logsData.length < 1"
        class="tips" >
        <span>No Data</span>
      </div>
    </div>
    <log-email-popup
      v-model="showEmailDialog"
      :sms-log-id="sme_log_id"></log-email-popup>
  </section>
</template>
<script>
import logEmailPopup from '@/views/accounts/components/popup/logEmailPopup'
import MixinOptions from '@/mixins/options'

export default {
  name: 'SupportLog',
  components:{
    logEmailPopup
  },
  mixins: [MixinOptions],
  props: {
    logsData: {
      type: Array,
      default: () => ([])
    },
    isClaim:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      type: 0,
      showEmailDialog:false,
      sme_log_id:0,
      typeOptions: [
        {
          name: 'All History',
          id: 0
        },
        {
          name: 'Remarks',
          id: 101
        },
        {
          name: 'Communications',
          id: 300
        },
        {
          name: 'Edits & Actions',
          id: 201
        }
      ]
    }
  },
  computed: {
    // handlerLogsData() {
    //   return this.logsData.map(item => {
    //     // item.message = item.message.replaceAll('\n', '<br />')
    //     item.message = String(item.message).replace(/\n/g, '<br />')
    //     return item
    //   })
    // }
  },
  methods: {
    handlerEmail(sms_log_id){
      this.sme_log_id = sms_log_id
      this.showEmailDialog = true
    },
    changeType(type) {
      this.$emit('change', type)
    },
    openFile(url) {
      if(!url) {
        return
      }
      window.open(url, '_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
.support-log {
    .svg-inline--fa {
      color: white;
      font-size: 24px;
    }
    .title-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .tips {
        padding-top: 50px;
        font-size: 14px;
        text-align: center;
      }
      .log-container {
        margin-top: 12px;
        .log-box {
          display: flex;
          margin-bottom: 15px;
          &:last-child {
            .left::after {
              width: 0;
            }
          }
          .left {
            position: relative;
            &::after {
              position: absolute;
              z-index: 1;
              content: "";
              width: 5px;
              background: #dddfe7;
              top: 50px;
              bottom: -15px;
              left: 50%;
              transform: translateX(-50%);
            }
            span {
              z-index: 2;
              display: block;
              width: 50px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              border-radius: 100%;
            }
            // .icon-box {
            //   text-align: center;
            // }
            .sms-icon {
              background: #68c23a;
            }
            .edit-icon {
              background: #e6a23d;
            }
            .remark-icon {
              background: #409eff;
            }
            .call-icon {
              background: #68c23a;
            }
            .ticket-icon {
              background: #91939a;
            }
          }
          .right {
            flex: 1;
            position: relative;
            margin-left: 15px;
            .info-container {
              //padding: 10px 15px 0 15px;
              border: 1px solid #c5e7b1;
              border-radius: 4px;
              background-color: #f0faeb;
              &.white {
                border: 1px solid #DDDFE7;
                background-color: white;
              }
              &.blue{
                background: #DBEDFF;
                border: 1px solid rgba(4, 66, 137, 0.2);
                .info{
                  border-bottom: 1px solid rgba(4, 66, 137, 0.2);
                }
                .table{
                  tr{
                    border-color: rgba(4, 66, 137, 0.2)!important;
                  }
                }
              }
              &.yellow{
                background: #FFFBDD;
                border: 1px solid rgba(176, 136, 0, 0.2);
                .info{
                  border-bottom: 1px solid rgba(176, 136, 0, 0.2);
                }
                .table{
                  tr{
                    border-color: rgba(176, 136, 0, 0.2)!important;
                  }
                }
              }
              &.green {
                background: #DCFFE4;
                border: 1px solid rgba(23, 111, 44, 0.2);
                .info{
                  border-bottom: 1px solid rgba(23, 111, 44, 0.2);
                }
                .table{
                  tr{
                    border-color: rgba(23, 111, 44, 0.2)!important;
                  }
                }
              }
              &.red{
                background: #FFE3E6;
                border: 1px solid rgba(158, 23, 35, 0.2);
                .info{
                  border-bottom: 1px solid rgba(158, 23, 35, 0.2);
                }
                .table{
                  tr{
                    border-color: rgba(158, 23, 35, 0.2)!important;
                  }
                }
              }
              .flex-sb{
                padding: 10px 15px 0 15px;
              }
              .message-content {
                //border-top: 1px solid #DDDFE7;
                padding: 8px 15px;
              }
            }
            .info-file {
              margin-top: 10px;
            }
            .info {
              padding: 5px 15px;
              border-bottom: 1px solid #DDDFE7;
              & > span {
                display: block;
                padding-bottom: 5px;
                font-size: 14px;
                font-weight: 500;
                color: #91939a;
                span {
                  display: inline-block;
                  padding-left: 5px;
                  font-weight: 400;
                }
              }
            }
            .file-container {
              margin-top: 10px;
            }
            .file-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 15px;
              padding: 0 15px;
              height: 65px;
              border: 1px solid #dddfe7;
              border-radius: 4px;
              background: #fcfcfc;
              &:last-child {
                margin-bottom: 5px;
              }
              .file-info {
                color: #616266;
                font-size: 16px;
              }
            }
            .blue {
              color: #1989fa;
            }
            .title {
              font-weight: bold;
              font-size: 16px;
            }
            .message-content {
              //margin: 0 -15px;
              padding: 5px 15px;
              //border-top: 1px solid #c5e7b1;
              white-space: pre-wrap;
            }
            .time {
              display: block;
              padding-left: 10px;
              // position: absolute;
              // top: 15px;
              // right: 15px;
              color: #91939a;
              font-size: 14px;
              font-weight: 500;
              white-space: nowrap;
            }
          }
        }
      }
}
.span-status {
  margin-right: 5px;
  padding: 2px 8px;
  border-radius: 25px;
  white-space: nowrap;
  height: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  &.blue {
    border: 1px solid #0366D6;
    color: #fff;
    background: #0366D6;
  }
  &.green {
    border: 1px solid #28A745;
    color: #fff;
    background: #28A745;
  }
  &.red{
    border: 1px solid #D73A49;
    color: #fff;
    background: #D73A49;
  }
}
.mg-b-0{
  margin-bottom: 0!important;
}
.table{
  tr{
    font-size: 14px!important;
    padding:8px 15px;
    td:first-child{
      font-weight: 600!important;
    }
  }
  tr:last-child{
    border-bottom: 0;
  }
}
</style>
